/* =============================================
   PUNTA BELLEZA — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ── CART DRAWER ──────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartBtns = document.querySelectorAll('.header-cart-btn');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) { cartOverlay.style.display = 'block'; }
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) { cartOverlay.style.display = 'none'; }
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
      const body = document.getElementById('cart-drawer-body');
      if (body) {
        const html = await fetch('/cart?section_id=cart-drawer-items');
        if (html.ok) {
          const text = await html.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const content = doc.querySelector('.cart-drawer__body-content');
          if (content) body.innerHTML = content.innerHTML;
        }
        const totalEl = document.getElementById('cart-total');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price);
        }
      }
    } catch (e) { console.error('Cart refresh error:', e); }
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── ADD TO CART ──────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.btn-add-cart');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form');
    if (!form) return;
    btn.disabled = true;
    btn.textContent = 'Agregando...';
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        btn.textContent = '✓ Agregado';
        btn.style.background = 'var(--pb-gold)';
        btn.style.color = '#000';
        setTimeout(() => {
          btn.textContent = 'Agregar al carrito';
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
        openCart();
      } else {
        btn.textContent = 'Agregar al carrito';
        btn.disabled = false;
      }
    } catch (err) {
      btn.textContent = 'Agregar al carrito';
      btn.disabled = false;
    }
  });

  // ── CART QTY CHANGE ──────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    if (!key) return;
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      const newQty = action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      refreshCartDrawer();
    } catch (err) { console.error(err); }
  });

  // ── CART REMOVE ──────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.cart-item__remove');
    if (!btn) return;
    const key = btn.dataset.key;
    if (!key) return;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      refreshCartDrawer();
    } catch (err) { console.error(err); }
  });

  // ── MOBILE MENU ──────────────────────────────
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const mobileClose = document.querySelector('.mobile-menu__close');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ── PRODUCT PAGE: THUMBNAIL GALLERY ─────────
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.pd-thumb');
    if (!thumb) return;
    const src = thumb.dataset.src;
    if (!src) return;
    const mainImg = document.querySelector('.pd-main-img img');
    if (mainImg) mainImg.src = src;
    document.querySelectorAll('.pd-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });

  // ── PRODUCT PAGE: VARIANT SELECTOR ──────────
  document.addEventListener('click', function (e) {
    const opt = e.target.closest('.variant-option');
    if (!opt) return;
    const group = opt.closest('.variant-options');
    if (group) group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
    opt.classList.add('selected');
    const variantId = opt.dataset.variantId;
    const hiddenInput = document.querySelector('input[name="id"]');
    if (hiddenInput && variantId) hiddenInput.value = variantId;
    const price = opt.dataset.price;
    const comparePrice = opt.dataset.comparePrice;
    if (price) {
      const priceEl = document.querySelector('.pd-price');
      if (priceEl) priceEl.firstChild.textContent = formatMoney(parseInt(price));
    }
  });

  // ── PRODUCT PAGE: QTY INPUT ──────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-input button');
    if (!btn) return;
    const input = btn.closest('.qty-input').querySelector('input');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'plus') val++;
    else if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    input.value = val;
  });

  // ── STICKY HEADER SCROLL EFFECT ─────────────
  const header = document.querySelector('.site-header');
  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    if (current > 80) {
      header && header.classList.add('scrolled');
    } else {
      header && header.classList.remove('scrolled');
    }
    lastScroll = current;
  }, { passive: true });

  // ── ANNOUNCEMENT BAR DISMISS ─────────────────
  const announceDismiss = document.querySelector('.announcement-bar__dismiss');
  if (announceDismiss) {
    announceDismiss.addEventListener('click', () => {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
      sessionStorage.setItem('pb-announce-dismissed', '1');
    });
    if (sessionStorage.getItem('pb-announce-dismissed')) {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

  // ── INIT CART COUNT ──────────────────────────
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
});
